import { useEffect } from 'react';

export const useFormCalculations = (formData, updateFormData) => {
  const recalculateTotals = (items) => {
    // Calculate net total (HT)
    const totalHT = items.reduce((sum, item) => sum + item.total_price, 0);
    
    // Calculate total tax from individual line items
    const totalTax = items.reduce((sum, item) => sum + (item.tax_amount || 0), 0);
    
    // Calculate total with tax (TTC)
    const totalTTC = totalHT + totalTax;

    // Group taxes by rate for taxes_detail
    const taxesByRate = {};
    items.forEach(item => {
      if (item.tax_rate) {
        const rate = item.tax_rate;
        if (!taxesByRate[rate]) {
          taxesByRate[rate] = 0;
        }
        taxesByRate[rate] += item.tax_amount || 0;
      }
    });
    
    // Convert to array format for taxes_detail
    const taxesDetail = Object.entries(taxesByRate).map(([rate, amount]) => ({
      rate: parseFloat(rate),
      amount: parseFloat(amount.toFixed(2)),
      code: null
    }));

    updateFormData({
      total_ht: totalHT,
      total_tax: totalTax,
      total_ttc: totalTTC,
      taxes_detail: taxesDetail
    });
  };

  // Automatically recalculate totals when items change
  useEffect(() => {
    if (formData?.items) {
      recalculateTotals(formData.items);
    }
  }, [formData?.items]);

  return {
    recalculateTotals
  };
};